var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status_tag",style:({color: _vm.colorTable[_vm.status]})},[_c('span',{class:[_vm.status === 2 ? 'end' : 'start'],domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }